export enum DceRequestStatus {
  WAITING = 'WAITING',
  IN_SEARCH = 'IN_SEARCH',
  IN_TRANSFORMATION = 'IN_TRANSFORMATION',
  FOUND = 'FOUND',
  SEARCH_FAILED = 'SEARCH_FAILED',
  DISCARDED = 'DISCARDED',
}
